(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratAssistantDialogController', ContratAssistantDialogController);

    ContratAssistantDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'Contrat'];

    function ContratAssistantDialogController($scope, $uibModalInstance, entity, Contrat) {
        var vm = this;
        var CHAT_RECOVERY_DELAY_MS = 2000;
        var CHAT_RECOVERY_MAX_ATTEMPTS = 8;
        vm.contrat = entity;
        vm.prompt = '';
        vm.messages = [];
        vm.includeSystemInstructions = true;
        vm.latestUsage = null;
        vm.errorMessage = null;
        vm.isSending = false;
        vm.didExecuteActions = false;
        vm.conversationId = generateConversationId();

        vm.askQuestion = askQuestion;
        vm.proposeAction = proposeAction;
        vm.executeActions = executeActions;
        vm.clear = clear;

        function askQuestion() {
            send('QUESTION');
        }

        function proposeAction(message) {
            if (!message || vm.isSending) {
                return;
            }
            send('ACTION', message.actionContextType || 'GENERAL');
        }

        function send(mode, actionContextType) {
            var prompt = (vm.prompt || '').trim();
            if (!prompt || vm.isSending) {
                return;
            }

            vm.errorMessage = null;
            vm.messages.push({
                role: 'user',
                content: prompt
            });
            vm.prompt = '';
            vm.isSending = true;

            Contrat.chatAssistant({id: vm.contrat.id}, {
                mode: mode,
                includeSystemInstructions: vm.includeSystemInstructions,
                actionContextType: actionContextType,
                clientConversationId: vm.conversationId,
                messages: vm.messages.map(function(message) {
                    return {
                        role: message.role,
                        content: message.content
                    };
                })
            }, function(result) {
                applyAssistantResult(result);
            }, function(error) {
                attemptChatRecovery(error, 0);
            });
        }

        function executeActions(message) {
            if (!message || !message.proposedActions || !message.proposedActions.length || message.isExecutingActions) {
                return;
            }

            vm.errorMessage = null;
            message.isExecutingActions = true;

            Contrat.executeAssistantActions({id: vm.contrat.id}, {
                actions: message.proposedActions,
                conversationId: vm.conversationId
            }, function(result) {
                message.isExecutingActions = false;
                message.actionsExecuted = true;
                message.executedActionSummaries = result.executedActionSummaries || [];
                vm.conversationId = result.conversationId || vm.conversationId;
                vm.didExecuteActions = true;
                Contrat.get({id: vm.contrat.id}, function(refreshedContrat) {
                    $scope.$emit('wamasysApp:contratUpdate', refreshedContrat);
                });
            }, function(error) {
                message.isExecutingActions = false;
                vm.errorMessage = (error.headers && error.headers('X-wamasysApp-detail')) || 'Execution impossible';
            });
        }

        function clear() {
            $uibModalInstance.close({
                reload: vm.didExecuteActions
            });
        }

        function applyAssistantResult(result) {
            vm.latestUsage = result.usage;
            vm.conversationId = result.conversationId || vm.conversationId;
            vm.messages.push({
                role: 'assistant',
                content: result.assistantMessage,
                shouldSuggestAction: !!result.shouldSuggestAction,
                actionContextType: result.actionContextType,
                proposedActions: result.proposedActions || [],
                proposedActionSummaries: result.proposedActionSummaries || [],
                canExecuteActions: !!result.canExecuteActions,
                isExecutingActions: false,
                actionsExecuted: false,
                executedActionSummaries: []
            });
            vm.errorMessage = null;
            vm.isSending = false;
        }

        function attemptChatRecovery(originalError, attemptNumber) {
            Contrat.recoverAssistantResponse({id: vm.contrat.id, conversationId: vm.conversationId}, function(result) {
                if (result && result.assistantMessage) {
                    applyAssistantResult(result);
                    return;
                }
                scheduleChatRecovery(originalError, attemptNumber);
            }, function() {
                scheduleChatRecovery(originalError, attemptNumber);
            });
        }

        function scheduleChatRecovery(originalError, attemptNumber) {
            if (attemptNumber + 1 >= CHAT_RECOVERY_MAX_ATTEMPTS) {
                vm.isSending = false;
                vm.errorMessage = (originalError && originalError.headers && originalError.headers('X-wamasysApp-detail'))
                    || 'Assistant indisponible';
                return;
            }
            setTimeout(function() {
                $scope.$applyAsync(function() {
                    attemptChatRecovery(originalError, attemptNumber + 1);
                });
            }, CHAT_RECOVERY_DELAY_MS);
        }

        function generateConversationId() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(character) {
                var randomValue = Math.random() * 16 | 0;
                var value = character === 'x' ? randomValue : ((randomValue & 0x3) | 0x8);
                return value.toString(16);
            });
        }
    }
})();
